module.exports = __webpack_public_path__ + "media/fonts/Lato-SemiBold-a911d29bdebbaa942376c564fc4511e6.woff";